import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { Button } from '../Button'
import {
  BUTTON_PADDINGS,
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFonts,
} from '../Button.h'

export interface IPrimarySubmitButtonProps extends IButtonProps {}

export const LogOutButton = ({
  title = '',
  type = 'submit',
  corners = ButtonCorners.CORNERS_10,
  paddings = [BUTTON_PADDINGS.SIZE_10],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorHovered = ButtonColors.COLOR_TEXT_SECONDARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.FontSmBold,
  ...rest
}: IPrimarySubmitButtonProps): JSX.Element | null =>
  title ? (
    <Button
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      colorHovered={colorHovered}
      colorDisabled={colorDisabled}
      borderWidth={borderWidth}
      font={font}
      title={title}
      type={type}
      {...rest}
    />
  ) : null
